// eventBus.js
import mitt from 'mitt'

// Create an event emitter instance
const emitter = mitt()

export default emitter
